import {
	SET_OFFER_TIMEOUT,
	RESET_OFFER_TIMEOUT,
	SET_OFFER_MINUTES_INCREASE,
	DEFINE_OFFER_TIMEOUT,
	CALL_TIMEOUT_ACTION
} from "../shared/constants";

export const initialState = { expireDate: "", timedOutAction: false };

export const offerTimeout = (state = initialState, action) => {
	switch (action.type) {
		case DEFINE_OFFER_TIMEOUT:
			return { ...state, expireDate: action.expireDate };

		case SET_OFFER_TIMEOUT:
			let date;

			if (action.expireDate == null) {
				date = new Date(action.searchCreatedDate);
				date.setMinutes(date.getMinutes() + SET_OFFER_MINUTES_INCREASE);
			} else if (Number.isInteger(parseInt(action.expireDate))) {
				date = new Date(action.expireDate);
			}

			return { ...state, expireDate: date };

		case RESET_OFFER_TIMEOUT:
			return state;

		case CALL_TIMEOUT_ACTION:
			return { ...state, timedOutAction: true };

		default:
			return state;
	}
};
